import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function TestimonialsSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="testimonios-titulo" data-id="element-179" data-mp="1n0k8fihpzo8n">
      <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="1r0ucuqpv66le">
        <SectionHeading id="testimonios-titulo" badge="Testimonios" badgeIcon={StarIcon} title={<>
              Lo Que Dicen <Accent data-id="element-182" data-mp="1i1z354nm2edc">Quienes Ya lo Tienen</Accent>
            </>} data-id="element-181" data-mp="1qzt2kogo9o4q" />

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-183" data-mp="141y5rz6k1p2m">
          {testimonials.map(({
          quote,
          initials,
          name,
          role
        }) => <li key={name} className="flex h-full flex-col rounded-2xl border border-cream-300/70 bg-cream-50 p-6" data-id="element-184" data-mp="1831jog51lb17">
              <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-185" data-mp="32h2k35g8q63e">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-ember-400 text-ember-400" aria-hidden="true" data-id="element-186" data-mp="2uzzwuxh4yoxd" />)}
              </span>
              <blockquote className="mt-4 text-sm leading-relaxed text-forest-700/90" data-id="element-187" data-mp="34r4bfw2wg7ro">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-188" data-mp="2zskkfh9g85sg">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest-600 text-xs font-bold text-cream-50" data-id="element-189" data-mp="2zunbm4mc84yr">
                  {initials}
                </span>
                <div data-id="element-190" data-mp="275q32t7xhmj7">
                  <p className="text-sm font-semibold text-forest-800" data-id="element-191" data-mp="2m0mmm2l6twbl">{name}</p>
                  <p className="text-xs text-forest-700/85" data-id="element-192" data-mp="2lyjn8ry5aqu7">{role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}